
export enum DefaultUsersIds {
    JmsAdmin = '00000000-0000-0000-0000-000000000001',
    WorkBuddyImporter = '00000000-0000-0000-0000-000000000002',
    AnonymousUser = '00000000-0000-0000-0000-000000000003',
    ExternalUser = '00000000-0000-0000-0000-000000000006',
    WorkBuddyConnect = '00000000-0000-0000-0000-000000000004',
    WorkBuddyRecurringJobScheduler = '00000000-0000-0000-0000-000000000005',
    WorkBuddyJobAutoCloseScheduler = '00000000-0000-0000-0000-000000000008',
    WorkBuddyReminderScheduler = '00000000-0000-0000-0000-000000000009',
    PhoneSystem = '00000000-0000-0000-0000-000000000006',
    ApiKeyUser = '00000000-0000-0000-0000-000000000007',
    WorkBuddy = '00000000-0000-0000-0000-000000009999',

    Me = '10000000-0000-0000-0000-000000000001',
}

export class DefaultUsers {
    public static readonly JmsAdmin = { _id: DefaultUsersIds.JmsAdmin, name: 'JMS Admin' };
    public static readonly WorkBuddy = { _id: DefaultUsersIds.WorkBuddy, name: 'WorkBuddy' };
    public static readonly WorkBuddyImporter = { _id: DefaultUsersIds.JmsAdmin, name: 'WorkBuddy IMPORTER' };
    public static readonly WorkBuddyConnect = { _id: DefaultUsersIds.WorkBuddyConnect, name: 'WorkBuddy Connect' };
    public static readonly WorkBuddyRecurringJobScheduler = { _id: DefaultUsersIds.WorkBuddyRecurringJobScheduler, name: 'WorkBuddy Recurring Job Scheduler' };
    public static readonly WorkBuddyJobAutoCloseScheduler = { _id: DefaultUsersIds.WorkBuddyJobAutoCloseScheduler, name: 'WorkBuddy Job Auto Close Scheduler' };
    public static readonly WorkBuddyReminderScheduler = { _id: DefaultUsersIds.WorkBuddyReminderScheduler, name: 'WorkBuddy Reminder Scheduler' };
    public static readonly AnonymousUser = { _id: DefaultUsersIds.AnonymousUser, name: 'Anonymous User' };
    public static readonly ExternalUser = { _id: DefaultUsersIds.AnonymousUser, name: 'External User' };
    public static readonly MeUser = { _id: DefaultUsersIds.Me, name: 'Me' };
    public static readonly ApiKeyUser = { _id: DefaultUsersIds.ApiKeyUser, name: 'API Key' };
}